module.exports = __webpack_public_path__ + "img/teams.24cf0fdc.svg";